module.exports = "<div class=\"{{ align }}\">\n  <app-title title=\"{{ title }}\"></app-title>\n  <div class=\"details\">\n    <div><img style=\"margin:auto;\" src=\"assets/images/loading-grey.svg\"></div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/loading/loading.component.html
// module id = ../../../../../src/app/shared/loading/loading.component.html
// module chunks = main